export function getManagerFieldApiParams(serviceRequest) {
  return serviceRequest?.value
    ? { view_request: serviceRequest.value }
    : undefined
}
